var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hot && (_vm.hot.length > 0))?_c('div',{attrs:{"id":"hot"}},[_c('div',{staticClass:"inner"},_vm._l((_vm.hot),function(item){return _c('router-link',{key:item,staticClass:"hot-item",attrs:{"to":`/main/search?kw=${item}`}},[_vm._v(_vm._s(item))])}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }